import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FormFieldKeyActionEnum } from "../../_common/enum/forms/formFieldKeyAction.enum";
import { IFormManage } from "../../_common/models/form";
import { formService } from "../../_services/form.service";
import { QuoteFiltersSection } from "./quotesFilterSection";


export function QuoteFilters(params: {
    setIsSaved?: () => any,
    firstName?: string,
    firstNameJointLife?: string | null
}) {

    const { formId } = useParams<{ formId: string }>();
    const _formId = Number(formId);
    const [data, setData] = useState<IFormManage>();
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [activeStep, setActiveStep] = useState<number>(0);
    const [stepWithLatestId, setStepWithLatestId] = useState<number | null>(null);

    useEffect(() => {
        fetchData();

    }, []);

    useEffect(() => {
        if (data) {
            if (activeStep === 0 || shouldShowReviewSection()) {
                resetActiveStep();
            }
            resetStepWithLatestId();
        }
    }, [data]);

    function fetchData(isOnSave?: boolean) {

        setLoading(true);

        return formService
            .get(_formId, null)
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => {
                setLoading(false);
                if (isOnSave == true) {
                    setIsSaving(false);
                }
            });
    }

    function getActiveStep() {
        let step: number | null = null;

        if (shouldShowReviewSection()) {
            return data?.formSectionList.length || 0;
        }

        if (data && data.formSectionList.length > 0) {
            data.formSectionList.forEach((item, index) => {
                if (!item.id && step === null) {
                    step = index;
                }
            })
        }
        return step || 0;
    }

    function resetActiveStep() {
        setActiveStep(getActiveStep());
    }

    function resetStepWithLatestId() {

        let step: number | null = null;
        if (data && data.formSectionList.length > 0) {
            data.formSectionList.forEach((item, index) => {
                if (item.id) {
                    step = index;
                }
            })
        }
        setStepWithLatestId(step);
    }

    function shouldShowReviewSection() {

        let shouldShowReview = false;
        if (data && data.formSectionList.length > 0) {
            shouldShowReview = !data.formSectionList.some((item, index) => {
                return !item.id
            })
        }
        return shouldShowReview;

    }


    return (
        <>
            <QuoteFiltersSection
                formTemplateSectionId={16}
                isSectionSaving={isSaving}
                actionId={FormFieldKeyActionEnum.Filter}
                onSave={() => params.setIsSaved?.()}
                firstName={params.firstName}
                firstNameJointLife={params.firstNameJointLife}
            />
        </>
    );
}